<div class="card">
    <div class="card-body">
<strong>Are you sure you want to remove the hold?</strong>
</div>
</div>
<div>
    <button mat-raised-button (click)="onClose()" class="backButton m-2" style = "float: right">No</button>
    <button mat-raised-button (click)="removeHold()" class="actionButton m-2" style = "float: right">Yes</button>   
</div>